import { createAction } from 'redux-actions';
import Types from './types';

export const resetMFAUserRequest = createAction(Types.RESET_MFA_USER_REQUEST);
export const resetMFAUserFulfilled = createAction(
  Types.RESET_MFA_USER_FULFILLED
);
export const resetMFAUserRejected = createAction(Types.RESET_MFA_USER_REJECTED);

export const activeCheckedUSerRequest = createAction(
  Types.ACTIVE_CHECKED_USER_REQUEST
);
export const activeCheckedUSerFulfilled = createAction(
  Types.ACTIVE_CHECKED_USER_FULFILLED
);
export const activeCheckedUSerRejected = createAction(
  Types.ACTIVE_CHECKED_USER_REJECTED
);

export const inactivateAllUsersRequest = createAction(
  Types.INACTIVE_CHECKED_USER_REQUEST
);
export const inactivateAllUsersFulfilled = createAction(
  Types.INACTIVE_CHECKED_USER_FULFILLED
);
export const inactivateAllUsersRejected = createAction(
  Types.INACTIVE_CHECKED_USER_REJECTED
);

export const removeAllSelectedUserRequest = createAction(
  Types.REMOVE_ALL_SELECTED_USER_REQUEST
);
export const removeAllSelectedUserFulfilled = createAction(
  Types.REMOVE_ALL_SELECTED_USER_FULFILLED
);
export const removeAllSelectedUserRejected = createAction(
  Types.REMOVE_ALL_SELECTED_USER_REJECTED
);

export const saveUrlConnectionRequest = createAction(
  Types.SAVE_URL_CONNECTION_REQUEST
);
export const saveUrlConnectionFulfilled = createAction(
  Types.SAVE_URL_CONNECTION_FULFILLED
);

export const saveChromeExtensionRequest = createAction(
  Types.SAVE_CHROME_EXTENSION_REQUEST
);
export const saveChromeExtensionFulfilled = createAction(
  Types.SAVE_CHROME_EXTENSION_FULFILLED
);

export const enableOrDesableRemoteProfileRequest = createAction(
  Types.ENABLE_OR_DISABLE_REMOTE_PROFILE_REQUEST
);
export const enableOrDesableRemoteProfileFulfilled = createAction(
  Types.ENABLE_OR_DISABLE_REMOTE_PROFILE_FULFILLED
);
export const enableOrDesableRemoteProfileRejected = createAction(
  Types.ENABLE_OR_DISABLE_REMOTE_PROFILE_REJECTED
);

export const getHistorySessionsRequest = createAction(
  Types.GET_HISTORY_SESSIONS_REQUEST
);
export const getHistorySessionsFulfilled = createAction(
  Types.GET_HISTORY_SESSIONS_FULFILLED
);
export const getHistorySessionsRejected = createAction(
  Types.GET_HISTORY_SESSIONS_REJECTED
);

export const exportHistorySessionCSVRequest = createAction(
  Types.EXPORT_HISTORY_SESSION_CSV_REQUEST
);
export const exportHistorySessionCSVRejected = createAction(
  Types.EXPORT_HISTORY_SESSION_CSV_REJECTED
);

export const toggleMFAToAllUserRequest = createAction(
  Types.ACTIVE_MFA_TO_ALL_USER_REQUEST
);
export const activeMFAToAllUserFulfilled = createAction(
  Types.ACTIVE_MFA_TO_ALL_USER_FULFILLED
);
export const activeMFAToAllUserRejected = createAction(
  Types.ACTIVE_MFA_TO_ALL_USER_REJECTED
);

export const getAllClientsRequest = createAction(Types.GET_ALL_CLIENTS_REQUEST);
export const getAllClientsFulfilled = createAction(
  Types.GET_ALL_CLIENTS_FULFILLED
);
export const getAllClientsRejected = createAction(
  Types.GET_ALL_CLIENTS_REJECTED
);

export const getAllClientsOperatorRequest = createAction(
  Types.GET_ALL_CLIENTS_OPERATOR_REQUEST
);
export const getAllClientsOperatorFulfilled = createAction(
  Types.GET_ALL_CLIENTS_OPERATOR_FULFILLED
);
export const getAllClientsOperatorRejected = createAction(
  Types.GET_ALL_CLIENTS_OPERATOR_REJECTED
);

export const testOpenApplicationRequest = createAction(
  Types.TEST_OPEN_APPLICATION_REQUEST
);
export const testOpenApplicationFulfilled = createAction(
  Types.TEST_OPEN_APPLICATION_FULFILLED
);
export const testOpenApplicationRejected = createAction(
  Types.TEST_OPEN_APPLICATION_REJECTED
);

export const clearTestOpenApplication = createAction(
  Types.CLEAR_TEST_OPEN_APPLICATION
);

export const sendEmailToResetPasswordRequest = createAction(
  Types.SEND_EMAIL_TO_RESET_PASSWORD_REQUEST
);
export const sendEmailToResetPasswordFulfilled = createAction(
  Types.SEND_EMAIL_TO_RESET_PASSWORD_FULFILLED
);
export const sendEmailToResetPasswordRejected = createAction(
  Types.SEND_EMAIL_TO_RESET_PASSWORD_REJECTED
);

export const editMaintenanceRequest = createAction(
  Types.EDIT_MAINTENANCE_REQUEST
);
export const editMaintenanceFulfilled = createAction(
  Types.EDIT_MAINTENANCE_FULFILLED
);
export const editMaintenanceRejected = createAction(
  Types.EDIT_MAINTENANCE_REJECTED
);

export const getMaintenanceRequest = createAction(
  Types.GET_MAINTENANCE_REQUEST
);
export const getMaintenanceFulfilled = createAction(
  Types.GET_MAINTENANCE_FULFILLED
);
export const getMaintenanceRejected = createAction(
  Types.GET_MAINTENANCE_REJECTED
);
export const clearMaintenanceData = createAction(Types.CLEAR_MAINTENANCE_DATA);

export const createUserInClientRequest = createAction(
  Types.CREATE_USER_IN_CLIENTE_REQUEST
);
export const createUserInClientFulfilled = createAction(
  Types.CREATE_USER_IN_CLIENTE_FULFILLED
);
export const createUserInClientRejected = createAction(
  Types.CREATE_USER_IN_CLIENTE_REJECTED
);

export const disableUserInClientRequest = createAction(
  Types.DISABLE_USER_IN_CLIENTE_REQUEST
);
export const disableUserInClientFulfilled = createAction(
  Types.DISABLE_USER_IN_CLIENTE_FULFILLED
);
export const disableUserInClientRejected = createAction(
  Types.DISABLE_USER_IN_CLIENTE_REJECTED
);

export const activeUserInClientRequest = createAction(
  Types.ACTIVE_USER_IN_CLIENTE_REQUEST
);
export const activeUserInClientFulfilled = createAction(
  Types.ACTIVE_USER_IN_CLIENTE_FULFILLED
);
export const activeUserInClientRejected = createAction(
  Types.ACTIVE_USER_IN_CLIENTE_REJECTED
);

export const removeSessionsRequest = createAction(
  Types.REMOVE_SESSIONS_REQUEST
);
export const removeSessionsFulfilled = createAction(
  Types.REMOVE_SESSIONS_FULFILLED
);
export const removeSessionsRejected = createAction(
  Types.REMOVE_SESSIONS_REJECTED
);

export const getClientByIdRequest = createAction(
  Types.GET_CLIENTS_BY_ID_REQUEST
);
export const getClientByIdFulfilled = createAction(
  Types.GET_CLIENTS_BY_ID_FULFILLED
);
export const getClientByIdRejected = createAction(
  Types.GET_CLIENTS_BY_ID_REJECTED
);

export const newClientRequest = createAction(Types.NEW_CLIENT_REQUEST);
export const newClientFulfilled = createAction(Types.NEW_CLIENT_FULFILLED);
export const newClientRejected = createAction(Types.NEW_CLIENT_REJECTED);

export const editClientRequest = createAction(Types.EDIT_CLIENT_REQUEST);
export const editClientFulfilled = createAction(Types.EDIT_CLIENT_FULFILLED);
export const editClientRejected = createAction(Types.EDIT_CLIENT_REJECTED);

export const newCloneClientRequest = createAction(
  Types.NEW_CLONE_CLIENT_REQUEST
);
export const newCloneClientFulfilled = createAction(
  Types.NEW_CLONE_CLIENT_FULFILLED
);
export const newCloneClientRejected = createAction(
  Types.NEW_CLONE_CLIENT_REJECTED
);

export const handleRemoveClientRequest = createAction(
  Types.REMOVE_CLIENT_REQUEST
);
export const handleRemoveClientFulfilled = createAction(
  Types.REMOVE_CLIENT_FULFILLED
);
export const handleRemoveClientRejected = createAction(
  Types.REMOVE_CLIENT_REJECTED
);

export const newApplicationRequest = createAction(
  Types.NEW_APPLICATION_REQUEST
);
export const newApplicationFulfilled = createAction(
  Types.NEW_APPLICATION_FULFILLED
);
export const newApplicationRejected = createAction(
  Types.NEW_APPLICATION_REJECTED
);

export const editApplicationRequest = createAction(
  Types.EDIT_APPLICATION_REQUEST
);
export const editApplicationFulfilled = createAction(
  Types.EDIT_APPLICATION_FULFILLED
);
export const editApplicationRejected = createAction(
  Types.EDIT_APPLICATION_REJECTED
);

export const setApplicationRequest = createAction(
  Types.SET_APPLICATION_REQUEST
);
export const setApplicationFulfilled = createAction(
  Types.SET_APPLICATION_FULFILLED
);
export const setApplicationRejected = createAction(
  Types.SET_APPLICATION_REJECTED
);

export const getApplicationsClientsRequest = createAction(
  Types.GET_APPLICATIONS_REQUEST
);
export const getApplicationsClientsFulfilled = createAction(
  Types.GET_APPLICATIONS_FULFILLED
);
export const getApplicationsClientsRejected = createAction(
  Types.GET_APPLICATIONS_REJECTED
);

export const getAvailableApplicationsRequest = createAction(
  Types.GET_AVAILABLE_APPLICATIONS_REQUEST
);
export const getAvailableApplicationsFulfilled = createAction(
  Types.GET_AVAILABLE_APPLICATIONS_FULFILLED
);
export const getAvailableApplicationsRejected = createAction(
  Types.GET_AVAILABLE_APPLICATIONS_REJECTED
);

export const applyConfigApplicationRequest = createAction(
  Types.APPLY_CONFIG_APPLICATION_REQUEST
);
export const applyConfigApplicationFulfilled = createAction(
  Types.APPLY_CONFIG_APPLICATION_FULFILLED
);
export const applyConfigApplicationRejected = createAction(
  Types.APPLY_CONFIG_APPLICATION_REJECTED
);

export const getSessionsClientsRequest = createAction(
  Types.GET_SESSIONS_CLIENTS_REQUEST
);
export const getSessionsClientsFulfilled = createAction(
  Types.GET_SESSIONS_CLIENTS_FULFILLED
);
export const getSessionsClientsRejected = createAction(
  Types.GET_SESSIONS_CLIENTS_REJECTED
);

export const getAllClientsUsersRequest = createAction(
  Types.GET_ALL_CLIENTS_USERS_REQUEST
);
export const getAllClientsUsersFulfilled = createAction(
  Types.GET_ALL_CLIENTS_USERS_FULFILLED
);
export const getAllClientsUsersRejected = createAction(
  Types.GET_ALL_CLIENTS_USERS_REJECTED
);

export const removeClientUserRequest = createAction(
  Types.REMOVE_CLIENT_USER_REQUEST
);
export const removeClientUserFulfilled = createAction(
  Types.REMOVE_CLIENT_USER_FULFILLED
);
export const removeClientUserRejected = createAction(
  Types.REMOVE_CLIENT_USER_REJECTED
);

export const editClientUserRequest = createAction(
  Types.EDIT_CLIENT_USER_REQUEST
);
export const editClientUserFulfilled = createAction(
  Types.EDIT_CLIENT_USER_FULFILLED
);
export const editClientUserRejected = createAction(
  Types.EDIT_CLIENT_USER_REJECTED
);

export const removeClientApplicationRequest = createAction(
  Types.REMOVE_CLIENT_APPLICATION_REQUEST
);
export const removeClientApplicationFulfilled = createAction(
  Types.REMOVE_CLIENT_APPLICATION_FULFILLED
);
export const removeClientApplicationRejected = createAction(
  Types.REMOVE_CLIENT_APPLICATION_REJECTED
);

export const removeClientWebApplicationRequest = createAction(
  Types.REMOVE_CLIENT_WEB_APPLICATION_REQUEST
);
export const removeClientWebApplicationFulfilled = createAction(
  Types.REMOVE_CLIENT_WEB_APPLICATION_FULFILLED
);
export const removeClientWebApplicationRejected = createAction(
  Types.REMOVE_CLIENT_WEB_APPLICATION_REJECTED
);

export const getAccessControlRequest = createAction(
  Types.GET_ACCESS_CONTROL_REQUEST
);
export const getAccessControlFulfilled = createAction(
  Types.GET_ACCESS_CONTROL_FULFILLED
);
export const getAccessControlRejected = createAction(
  Types.GET_ACCESS_CONTROL_REJECTED
);

export const setAccessControlRequest = createAction(
  Types.SET_ACCESS_CONTROL_REQUEST
);
export const setAccessControlFulfilled = createAction(
  Types.SET_ACCESS_CONTROL_FULFILLED
);
export const setAccessControlRejected = createAction(
  Types.SET_ACCESS_CONTROL_REJECTED
);

export const exportUsersCSVRequest = createAction(
  Types.EXPORT_USERS_CSV_REQUEST
);
export const exportUsersCSVRejected = createAction(
  Types.EXPORT_USERS_CSV_REJECTED
);

export const importUsersCSVRequest = createAction(
  Types.IMPORT_USERS_CSV_REQUEST
);
export const importUsersCSVFulfilled = createAction(
  Types.IMPORT_USERS_CSV_FULFILLED
);
export const importUsersCSVRejected = createAction(
  Types.IMPORT_USERS_CSV_REJECTED
);

export const importClientsCSVRequest = createAction(
  Types.IMPORT_CLIENTS_CSV_REQUEST
);
export const importClientsCSVFulfilled = createAction(
  Types.IMPORT_CLIENTS_CSV_FULFILLED
);
export const importClientsCSVRejected = createAction(
  Types.IMPORT_CLIENTS_CSV_REJECTED
);

export const inactivateMultipleApplicationsRequest = createAction(
  Types.INACTIVATE_MULTIPLE_APPLICATIONS_REQUEST
);
export const inactivateMultipleApplicationsFulfilled = createAction(
  Types.INACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED
);
export const inactivateMultipleApplicationsRejected = createAction(
  Types.INACTIVATE_MULTIPLE_APPLICATIONS_REJECTED
);

export const activateMultipleApplicationsRequest = createAction(
  Types.ACTIVATE_MULTIPLE_APPLICATIONS_REQUEST
);
export const activateMultipleApplicationsFulfilled = createAction(
  Types.ACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED
);
export const activateMultipleApplicationsRejected = createAction(
  Types.ACTIVATE_MULTIPLE_APPLICATIONS_REJECTED
);

export const removeMultipleApplicationsRequest = createAction(
  Types.REMOVE_MULTIPLE_APPLICATIONS_REQUEST
);
export const removeMultipleApplicationsFulfilled = createAction(
  Types.REMOVE_MULTIPLE_APPLICATIONS_FULFILLED
);
export const removeMultipleApplicationsRejected = createAction(
  Types.REMOVE_MULTIPLE_APPLICATIONS_REJECTED
);

export const getBlockMultipleSessionReportFulfilled = createAction(
  Types.GET_BLOCK_MULTIPLE_SESSION_REPORT_FULFILLED
);
export const getBlockMultipleSessionReportRejected = createAction(
  Types.GET_BLOCK_MULTIPLE_SESSION_REPORT_REJECTED
);
export const getBlockMultipleSessionReportRequest = createAction(
  Types.GET_BLOCK_MULTIPLE_SESSION_REPORT_REQUEST
);

export const getConnectionTypeReportFulfilled = createAction(
  Types.GET_CONNECTION_TYPE_REPORT_FULFILLED
);
export const getConnectionTypeReportRejected = createAction(
  Types.GET_CONNECTION_TYPE_REPORT_REJECTED
);
export const getConnectionTypeReportRequest = createAction(
  Types.GET_CONNECTION_TYPE_REPORT_REQUEST
);

export const getMFAReportFulfilled = createAction(
  Types.GET_MFA_REPORT_FULFILLED
);
export const getMFAReportRejected = createAction(Types.GET_MFA_REPORT_REJECTED);
export const getMFAReportRequest = createAction(Types.GET_MFA_REPORT_REQUEST);

export const getUseProfileReportFulfilled = createAction(
  Types.GET_USE_PROFILE_REPORT_FULFILLED
);
export const getUseProfileReportRejected = createAction(
  Types.GET_USE_PROFILE_REPORT_REJECTED
);
export const getUseProfileReportRequest = createAction(
  Types.GET_USE_PROFILE_REPORT_REQUEST
);

export const getClientVirtualizerReportFulfilled = createAction(
  Types.GET_CLIENT_VIRTUALIZER_REPORT_FULFILLED
);
export const getClientVirtualizerReportRejected = createAction(
  Types.GET_CLIENT_VIRTUALIZER_REPORT_REJECTED
);
export const getClientVirtualizerReportRequest = createAction(
  Types.GET_CLIENT_VIRTUALIZER_REPORT_REQUEST
);

export const getActivateReportFulfilled = createAction(
  Types.GET_ACTIVATE_REPORT_FULFILLED
);
export const getActivateReportRejected = createAction(
  Types.GET_ACTIVATE_REPORT_REJECTED
);
export const getActivateReportRequest = createAction(
  Types.GET_ACTIVATE_REPORT_REQUEST
);

export const getSaltReportFulfilled = createAction(
  Types.GET_SALT_REPORT_FULFILLED
);
export const getSaltReportRejected = createAction(
  Types.GET_SALT_REPORT_REJECTED
);
export const getSaltReportRequest = createAction(Types.GET_SALT_REPORT_REQUEST);

export const exportClientSummaryRequest = createAction(
  Types.EXPORT_CLIENT_SUMMARY_REQUEST
);
export const exportClientSummaryFulfilled = createAction(
  Types.EXPORT_CLIENT_SUMMARY_FULFILLED
);
export const exportClientSummaryRejected = createAction(
  Types.EXPORT_CLIENT_SUMMARY_REJECTED
);

export const exportUserSummaryRequest = createAction(
  Types.EXPORT_USER_SUMMARY_REQUEST
);
export const exportUserSummaryFulfilled = createAction(
  Types.EXPORT_USER_SUMMARY_FULFILLED
);
export const exportUserSummaryRejected = createAction(
  Types.EXPORT_USER_SUMMARY_REJECTED
);
export const forceResetPasswordSelectedUsersRequest = createAction(
  Types.FORCE_RESET_PASSWORD_SELECTED_USERS_REQUEST
);
export const forceResetPasswordSelectedUsersFulfilled = createAction(
  Types.FORCE_RESET_PASSWORD_SELECTED_USERS_FULFILLED
);
export const forceResetPasswordSelectedUsersRejected = createAction(
  Types.FORCE_RESET_PASSWORD_SELECTED_USERS_REJECTED
);

export const enableUserDeviceValidationBypassRequest = createAction(
  Types.ENABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST
);
export const enableUserDeviceValidationBypassFulfilled = createAction(
  Types.ENABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED
);
export const enableUserDeviceValidationBypassRejected = createAction(
  Types.ENABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED
);
export const disableUserDeviceValidationBypassRequest = createAction(
  Types.DISABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST
);
export const disableUserDeviceValidationBypassFulfilled = createAction(
  Types.DISABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED
);
export const disableUserDeviceValidationBypassRejected = createAction(
  Types.DISABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED
);
